// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\StripeConnectRegisterResponse

export type StripeConnectRegisterApiResponse = {
	url: string | null;
};

export type StripeConnectRegister = {
	url: string | null;
};

export function hydrateStripeConnectRegister(data: StripeConnectRegisterApiResponse): StripeConnectRegister {
	return { ...data };
}